import {generatePath} from 'react-router-dom';
import {RenewalClickSigningRoute} from '../../../config/routes';
import {SIGNING_RESULT_MESSAGE} from '../constants/renewalClick';

// DocuSign runs in its own tab. The renewal tab opens it on /sign, which issues the
// session and redirects to DocuSign; DocuSign then returns it to /signing-complete.
const SIGNING_TAB_NAME = 'wobiRenewalSigning';

// Named, so reopening reuses the same tab. Returns null when the popup is blocked.
export const openSigningTab = (shortLinkKey) =>
  window.open(generatePath(RenewalClickSigningRoute.pathname, {shortLinkKey}), SIGNING_TAB_NAME);

// Called from inside the signing tab. Returns false when there is no renewal tab to report to.
export const reportToRenewalTab = (shortLinkKey, event) => {
  if (!window.opener || window.opener.closed) return false;
  window.opener.postMessage({type: SIGNING_RESULT_MESSAGE, event, shortLinkKey}, window.location.origin);
  window.close();
  return true;
};
